import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import Nav2 from "@/components/Layout/Nav2";
import Footer from "@/components/Layout/Footer";

import HeaderBar from "@/components/table/HeaderBar";
import Tabs from "@/components/table/Tabs";
import FooterStats from "@/components/table/FooterStats";

import LiveTableCanvas from "@/components/table/liveTable/LiveTableCanvas";
import LiveTableSidebar from "@/components/table/liveTable/LiveTableSidebar";

import BookTableCanvas from "@/components/table/bookTable/BookTableCanvas";
import Sidebar from "@/components/table/Sidebar";
import TableCanvas from "@/components/table/TableCanvas";
import TableHistory from "./table-history";

import useAuth from "@/hooks/useAuth";
import {
  fetchAllFloors,
  fetchAllRooms,
  fetchAllTables,
  updateTableStatusById,
  addBookingToTable,
  updateBookingInTable,
  closeAddNewBookingTableModal,
} from "@/redux/slice/table-slice/table-slice";
import BookTableFooter from "@/components/table/bookTable/BookTableFooter";
import LiveFooter from "@/components/table/liveTable/LiveFooter";
import TableSkeleton from "@/components/table/TableSkeleton";
import TableZoomAble from "@/components/table/TableZoomAble";
import LiveBookingDetails from "@/components/table/liveTable/LiveBookingDetails";
import OrderDetails from "@/components/TakeOder/OrderDetails";
import Complementary from "@/components/TakeOder/Complementary";
import BillingPage from "@/components/TakeOder/billingPage";
import SetTime from "@/components/TakeOder/setTime";
import Tips from "@/components/TakeOder/tips";
import ConvertOrder from "@/components/TakeOder/convertOrder";
import SplitPayment from "@/components/TakeOder/splitPayment";
import CourseWisePay from "@/components/TakeOder/courseWisePay";
import BookingDetails from "@/components/table/bookTable/BookingDetails";
import QuickTableModal from "@/components/table/liveTable/QuickTableModal";
import hasPermission from "@/hooks/hasPermission";

function TablePage() {
  const dispatch = useDispatch();
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [orderDetailsId, setOrderDetailsId] = useState(null);
  const [billPage, setBillPage] = useState(false);
  const [deliveryInfoPage, setDeliveryInfoPage] = useState(false);
  const [tipsPage, setTipsPage] = useState(false);
  const [setTimePage, setSetTimePage] = useState(false);
  const [convertOrder, setConvertOrder] = useState(false);
  const [splitPaymentPage, setSplitPaymentPage] = useState(false);
  const [courseWisePay, setCourseWisePay] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [preOrderTimePopup, setPreOrderTimePopup] = useState(false);
  const [preOrderAdvancePopup, setPreOrderAdvancePopup] = useState(false);
  const [activeOrderSection, setActiveOrderSection] = useState("New Order");
  const [checkoutData, setCheckoutData] = useState(null);
  const [complementaryPage, setComplementaryPage] = useState(false);
  const [quickTable, setQuickTable] = useState(null);

  const { selectedRoom, selectedFloor } = useSelector(
    (state) => state.table.table,
  );
  const { liveTablePopup, liveTableDetails } = useSelector(
    (state) => state.table.liveTable,
  );
  const { bookingTablePopup, bookingDetails } = useSelector(
    (state) => state.table.bookingTable,
  );

  const [searchParams] = useSearchParams();
  const initialTabFromUrl = searchParams.get("tab");

  const getInitialTab = () => {
    if (initialTabFromUrl) return initialTabFromUrl;
    if (hasPermission("table.live_table")) return "live";
    if (hasPermission("table.book_table")) return "book";
    if (hasPermission("table.add_edit_table")) return "add-edit";
    if (hasPermission("table.table_history")) return "history";
    return "live";
  };

  const [activeTab, setActiveTab] = useState(getInitialTab);
  const [isItemEdit, setIsItemEdit] = useState(false);
  const [selectedTableSizeUpdate, setSelectedTableSizeUpdate] = useState(null);

  useEffect(() => {
    if (!user?.restaurant_id) return;
    dispatch(fetchAllFloors(user.restaurant_id));
  }, [user?.restaurant_id, dispatch]);

  useEffect(() => {
    if (selectedFloor?.id) {
      dispatch(
        fetchAllRooms({
          restaurantId: user.restaurant_id,
          floorId: selectedFloor.id,
        }),
      );
    }
  }, [selectedFloor?.id, dispatch]);

  useEffect(() => {
    if (selectedRoom?.id) {
      setLoading(false);
      dispatch(fetchAllTables(selectedRoom?.id));
    } else {
      setLoading(false);
    }
  }, [selectedRoom, dispatch]);


  // Close Add New Booking Modal on Tab Change
  useEffect(() => {
    dispatch(closeAddNewBookingTableModal());
  }, [activeTab]);

  // Show loading skeleton while fetching data
  if (loading) {
    return <TableSkeleton />;
  }

  return (
    <div className="dark h-screen w-full flex flex-col bg-cblack">
      {/* TOP NAV */}
      <Nav2 />

      {/* PAGE BODY */}
      <div className="flex-1 flex overflow-hidden text-white mt-3">
        {/* LIVE TAB */}
        {activeTab === "live" && hasPermission("table.live_table") && (
          <>
            {/* <MainContent> */}
            <div className="flex-1 flex flex-col overflow-hidden relative">
              <div className=" z-10 absolute top-0 left-0 px-4 w-full h-[110px] ">
                <HeaderBar />
                <Tabs
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  setIsItemEdit={setIsItemEdit}
                />
              </div>
              <div className="flex-1 overflow-auto pl-3 tab-max:pl-3 pr-3 mt-[92px] tab-max:mt-28 ">
                <TableZoomAble>
                  <LiveTableCanvas />
                </TableZoomAble>
              </div>
              <div>
                <LiveBookingDetails
                  isOpen={liveTablePopup}
                  itemsDialog={liveTableDetails}
                  tableType="live_table"
                  setOrderDetailsId={setOrderDetailsId}
                  setQuickTable={setQuickTable}
                />
                <QuickTableModal
                  isOpen={quickTable ? true : false}
                  data={quickTable}
                  onClose={() => setQuickTable(null)}
                />
                {orderDetailsId != null && (
                  <div className=" fixed top-0 left-0 w-screen h-screen bg-black/70 flex items-center justify-center z-50 ">
                    <OrderDetails
                      setOrderDetailsId={setOrderDetailsId}
                      orderDetailsId={orderDetailsId}
                      setCheckoutData={setCheckoutData}
                      checkoutData={checkoutData}
                      setBillPage={setBillPage}
                      setSetTimePage={setSetTimePage}
                      setConvertOrder={setConvertOrder}
                      setActiveOrderSection={setActiveOrderSection}
                      setComplementaryPage={setComplementaryPage}
                      redirectToTakeOrder={true}
                    />
                  </div>
                )}

                {complementaryPage && (
                  <div className=" fixed top-0 left-0 w-screen h-screen bg-black/70 flex items-center justify-center z-50 ">
                    <Complementary
                      checkoutData={checkoutData}
                      setComplementaryPage={setComplementaryPage}
                    />
                  </div>
                )}
                {billPage && (
                  <div className=" fixed top-0 left-0 w-screen h-screen bg-black/70 flex items-center justify-center z-50 ">
                    <BillingPage
                      setBillPage={setBillPage}
                      setTipsPage={setTipsPage}
                      setSplitPaymentPage={setSplitPaymentPage}
                      setCourseWisePay={setCourseWisePay}
                    />
                  </div>
                )}

                {setTimePage && (
                  <div className=" fixed top-0 left-0 w-screen h-screen bg-black/70 flex items-center justify-center z-50 ">
                    <SetTime setSetTimePage={setSetTimePage} />
                  </div>
                )}
                {tipsPage && (
                  <div className=" fixed top-0 left-0 w-screen h-screen bg-black/70 flex items-center justify-center z-50 ">
                    <Tips setTipsPage={setTipsPage} />
                  </div>
                )}
                {convertOrder && (
                  <div className=" fixed top-0 left-0 w-screen h-screen bg-black/70 flex items-center justify-center z-50 ">
                    <ConvertOrder
                      setConvertOrder={setConvertOrder}
                      setDeliveryInfoPage={setDeliveryInfoPage}
                    />
                  </div>
                )}
                {splitPaymentPage && (
                  <div className=" fixed top-0 left-0 w-screen h-screen bg-black/70 flex items-center justify-center z-50 ">
                    <SplitPayment setSplitPaymentPage={setSplitPaymentPage} />
                  </div>
                )}
                {courseWisePay && (
                  <div className=" fixed top-0 left-0 w-screen h-screen bg-black/70 flex items-center justify-center z-50 ">
                    <CourseWisePay setCourseWisePay={setCourseWisePay} />
                  </div>
                )}
              </div>
              <LiveFooter />
              <div>
                <BookTableFooter activeTab={activeTab} />
              </div>
            </div>
            {/* </MainContent> */}
            <LiveTableSidebar />
          </>
        )}

        {/* BOOK TAB */}
        {activeTab === "book" && hasPermission("table.book_table") && (
          <>
            {/* <MainContent> */}
            <div className="flex-1 flex flex-col overflow-hidden relative">
              <div className=" z-10 absolute top-0 left-0 px-4 w-full h-[110px] ">
                <HeaderBar />
                <Tabs
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  setIsItemEdit={setIsItemEdit}
                />
              </div>
              <div className="flex-1 overflow-auto pl-3 tab-max:pl-3 pr-3 mt-[92px] tab-max:mt-28">
                <TableZoomAble>
                  <BookTableCanvas />
                </TableZoomAble>
                <div>
                  {bookingTablePopup && (
                    <BookingDetails
                      itemsDialog={bookingDetails}
                      tableType="book_table"
                    />
                  )}
                </div>
              </div>
              <BookTableFooter />
            </div>
            {/* </MainContent> */}
            <Sidebar
              selectedTableSizeUpdate={selectedTableSizeUpdate}
              // isItemEdit={isItemEdit}
              // setIsItemEdit={setIsItemEdit}
              activeTab={activeTab}
            />
          </>
        )}

        {/* ADD / EDIT TAB */}
        {activeTab === "add-edit" && hasPermission("table.add_edit_table") && (
          <>
            {/* <MainContent> */}
            <div className="flex-1 flex flex-col overflow-hidden relative">
              <div className=" z-10 absolute top-0 left-0 px-4 pb-8 w-full h-[90px] bg-color1 ">
                <HeaderBar setIsItemEdit={setIsItemEdit} />
                <Tabs
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  setIsItemEdit={setIsItemEdit}
                />
              </div>
              <div className="flex-1 overflow-auto pl-3 tab-max:pl-3 pr-3 mt-[68px] tab-max:mt-[90px]">
                {/* <div className=" w-[1200px] h-[1000px] bg-zinc-800 relative"> */}
                <TableZoomAble>
                  <TableCanvas
                    setSelectedTableSizeUpdate={setSelectedTableSizeUpdate}
                    isItemEdit={isItemEdit}
                    setIsItemEdit={setIsItemEdit}
                  />
                </TableZoomAble>
                {/* </div> */}
              </div>
              <FooterStats />
            </div>
            {/* </MainContent> */}
            <Sidebar
              selectedTableSizeUpdate={selectedTableSizeUpdate}
              isItemEdit={isItemEdit}
              setIsItemEdit={setIsItemEdit}
            />
          </>
        )}

        {/* HISTORY TAB */}
        {activeTab === "history" && hasPermission("table.table_history") && (
          <>
            {/* <MainContent> */}
            <div className="flex-1 flex flex-col overflow-hidden relative">
              <div className=" z-10 absolute top-0 left-0 px-4 w-full h-[110px] ">
                <HeaderBar />

                <Tabs
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  setIsItemEdit={setIsItemEdit}
                />
              </div>
              <div className="flex-1 overflow-auto pl-3 tab-max:pl-3 pr-3 mt-[68px] tab-max:mt-[90px]">
                <TableHistory />
              </div>
              {/* <BookTableFooter /> */}
            </div>
            {/* </MainContent> */}
            {/* <Sidebar
              selectedTableSizeUpdate={selectedTableSizeUpdate}
              // isItemEdit={isItemEdit}
              // setIsItemEdit={setIsItemEdit}
              activeTab={activeTab}
            /> */}
          </>
        )}
        {/* {activeTab === "history" && (
          <>
            <MainContent>
            <div className="flex-1 flex flex-col overflow-hidden">
              <div className="flex-1 overflow-auto pl-7 pr-3">
                <div className=" z-10 absolute top-0 left-0 px-4 w-full h-[110px] ">
                  <HeaderBar />
                  <Tabs activeTab={activeTab} setActiveTab={setActiveTab} setIsItemEdit={setIsItemEdit} />
                </div>
                  <div className="text-gray-500 p-10 text-xl">
                    Table History Coming…
                  </div>
              </div>
            </div>
            </MainContent>
            <Sidebar />
          </>
        )} */}
      </div>

      {/* GLOBAL FOOTER */}
      <Footer />
    </div>
  );
}

export default TablePage;
